module.exports = __webpack_public_path__ + "img/astral_15.ff70bea2.svg";